import { ReactNode, createContext, useContext, useEffect, useState } from "react";
import { useFilterStore } from "./stores/FilterStore";

interface FormContextProps {
  formValues: FilterValues;
  setTempValues: (key: FilterKey, value: string) => void;
}

const FormContext = createContext<FormContextProps | undefined>(undefined);

type FilterValues = {
  county: string;
  bedrooms: string;
  minPrice: string;
  maxPrice: string;
};

type FilterKey = keyof FilterValues;

export const FormProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { county, bedrooms, minPrice, maxPrice } = useFilterStore([
    "county",
    "bedrooms",
    "minPrice",
    "maxPrice",
  ]);

  const [formValues, setFormValues] = useState<FilterValues>({
    county,
    bedrooms,
    minPrice,
    maxPrice,
  });

  useEffect(() => {
    setFormValues({
      county,
      bedrooms,
      minPrice,
      maxPrice,
    });
  }, [county, bedrooms, minPrice, maxPrice]);

  const setTempValues = (key: FilterKey, value: string) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };

  return (
    <FormContext.Provider value={{ formValues, setTempValues }}>{children}</FormContext.Provider>
  );
};

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useFormContext must be used within a FormProvider");
  }
  return context;
};
